import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useSelectFeatureStatus } from 'hooks/useSelectFeatureStatus';
import { PathName } from 'router/paths';

import { Features, FeatureStatusType } from 'models/user.types';

interface RequireFeatureFlagProps {
  children?: ReactNode;
  fallback?: ReactNode;
  flag: keyof Features;
  status?: FeatureStatusType;
}

/**
 * Blocks the route when the feature matches the given status (default: 'disabled').
 * Falls back to a redirect to NotFound unless a custom fallback is provided.
 */
const RequireFeatureFlag = ({ children, fallback, flag, status }: RequireFeatureFlagProps) => {
  const isBlocked = useSelectFeatureStatus(flag, status);

  if (isBlocked) {
    return <>{fallback ?? <Navigate to={PathName.NotFound} replace />}</>;
  }

  return <>{children ?? <Outlet />}</>;
};

export default RequireFeatureFlag;
